<template>
  <div class="room-doc-view-component">
    <div class="room-doc-canvas-view"
         ref="roomDocView"
         :style="{}">
      <div />
    </div>
  </div>
</template>

<script>
import {RoomDocCanvas} from "@/components/Room/Doc/RoomDocCanvas";
import {mapActions, mapGetters} from 'vuex';
import _ from "lodash";

const RoomDocViews = {}

export default {
  name: 'RoomDocView',
  props: {
    roomGroupId: String
  },
  data() {
    let data = {
      prevToolkit: null,
      toolkit: 'Pencil',
      setPageTimer: null,
      tmp_page_no: 0,
      isModalDrawtool: true,
      colorList: [
        '#000000', '#FFFFFF', '#7F7F7F', '#C3C3C3', '#880015',
        '#B97A57', '#FF0000', '#FFAEC9', '#FF7F27', '#FFC90E',
        '#FFF200', '#EFE4B0', '#22B14C', '#B5E61D', '#6EFFB9',
        '#0000FF', '#99D9EA', '#3F48CC', '#7092BE', '#A349A4'
      ],
      color: '#000000',
      strokeWidthInp: 14,
      strokeWidth: 7,
      canvasToolLineWidth: {},
      tools: {
        colorEnableTools: ['LaserPointer', 'Pencil', 'Highlighter', 'Text',
                           'Circle', 'Rectangle', 'Diamond', 'Pentagon', 'Star', 'Triangle', 'Line', 'TwoLines'],
        strokeWidthEnbaleTools: [
          'Pencil', 'Highlighter', 'Eraser',
          'Circle', 'Rectangle', 'Diamond', 'Pentagon', 'Star', 'Triangle', 'Line', 'TwoLines'
        ],
        figureTools: [
          'Circle', 'Rectangle', 'Diamond', 'Pentagon', 'Star', 'Triangle', 'Line', 'TwoLines'
        ]
      },
      textSizeList: [10, 30, 60],
      textSize: null
    };
    return data;
  },

  watch: {
    'me.roomUserRole.draw': function (enable) {
      this.setPermission();
    },
    'me.roomGroupId': function (enable) {
      this.setPermission();
    },
    'roomDoc.docId': function (docId) {
      clearTimeout(this.setPageTimer);
      this.setPageTimer = setTimeout(() => {
        this.setPage(this.currentPageKey);
      }, 20);
    },
    'roomDoc.docPageId': function (docId) {
      clearTimeout(this.setPageTimer);
      this.setPageTimer = setTimeout(() => {
        this.setPage(this.currentPageKey);
      }, 20);
    },
    'roomDoc.roomGroupId': function (docId) {
      clearTimeout(this.setPageTimer);
      this.setPageTimer = setTimeout(() => {
        this.setPage(this.currentPageKey);
      }, 20);
    },
    toolkit: function (toolkit, prevToolkit) {
      toolkit = this.csCanvas.getToolkit(toolkit);
      if (toolkit.style.strokeStyle) {
        this.color = toolkit.style.strokeStyle;
      }
      if (toolkit.style.lineWidth) {
        this.strokeWidth = toolkit.style.lineWidth;
      }
    },
    color: function (c) {
      let toolkit = this.csCanvas.getCurrentToolkit();
      toolkit.style.strokeStyle = c;
      const paletteEl = this.$parent.$refs.palette
      if (paletteEl) {
        paletteEl.selectedColor = c;
      }
    },
    strokeWidth: function (strokeWidth) {
      let n = parseInt(strokeWidth);
      n = Math.max(n, 2);
      n = Math.min(n, 70);
      strokeWidth = '' + n;

      let toolkit = this.csCanvas.getCurrentToolkit();
      toolkit.style.lineWidth = strokeWidth;
      const paletteEl = this.$parent.$refs.palette
      if (paletteEl) {
        paletteEl.selectedStrokeWidth = strokeWidth;
      }
    },
    strokeWidthInp: function (strokeWidth) {
      let n = parseInt(strokeWidth);
      n = Math.max(n, 2);
      n = Math.min(n, 70);
      strokeWidth = '' + n;

      let toolkit = this.csCanvas.getCurrentToolkit();
      toolkit.style.lineWidth = strokeWidth;
    }
  },

  computed: {
    ...mapGetters('room', ['room', 'isRoomMode', 'isInRoomGroup']),
    ...mapGetters('roomGroup', ['isInRoomGroup', 'getRoomGroupName']),
    ...mapGetters('doc', ['getRoomDoc', 'getRoomDocFile', 'getRoomDocFilePage', 'isWhiteBoardFile']),
    ...mapGetters('user', ['me', 'hasRoleFunction', 'hasEmceeRole', 'hasRoomGroupRole']),
    ...mapGetters('roomSetting', ['roomSetting']),

    roomDoc: function () {
      return this.getRoomDoc(this.roomGroupId)
    },
    roomDocFile: function () {
      return this.getRoomDocFile(this.roomDoc)
    },
    roomDocFilePage: function () {
      if (!this.roomDocFile) {
        return null;
      }

      if (!this.roomDocFile.currDocPageId) {
        if (this.roomDocFile.pages) {
          return this.roomDocFile.pages[0];
        }
      }

      return this.getRoomDocFilePage({
        roomGroupId: this.roomDocFile.roomGroupId,
        docId: this.roomDocFile.docId,
        docPageId: this.roomDocFile.currDocPageId,
      })
    },
    currentPageKey: function () {
      return (this.roomDoc.roomGroupId ? this.roomDoc.roomGroupId + '.' : '') + this.roomDoc.docId + '@' +
             (this.roomDoc.docPageId ? this.roomDoc.docPageId : 'null')
    },
    currentPageNo: function () {
      return this.tmp_page_no || this.roomDocFile.currDocPageSeq;
    },
    notInRoomGroup: function () {
      return this.isRoomMode('group') && !this.isInRoomGroup()
    },
    textItemStyle() {
      return (size) => {
        return {
          width: '100%',
          height: '100%',
          background: `url('${require('@/assets/roomType/lms/img/text_on.svg')}') no-repeat center / ${size + 20}% auto`
        }
      }
    },
    textItemClass() {
      return textSize => {
        return {
          'selected': textSize === this.textSize && this.toolkit === 'Text'
        }
      }
    },
    textItemImg() {
      const status = this.toolkit === 'Text' ? 'on' : 'off';
      return require(`@/assets/roomType/lms/img/text_${status}.svg`);
    }
  },

  created() {
    this.$roomApi.addEventListeners((this._events = _Events()), this)
  },

  mounted() {
    if (!this.roomDocFile) {
      console.warn('roomDocFile is null :', this.roomDoc);
      return;
    }

    this.initCanvas()

    // this.setRandomColorList()

    this.setPage()

    this.resizeObserver = new ResizeObserver(entries => {
      this.csCanvas.redraw();
    });
    this.resizeObserver.observe(this.$el);
    // if(Room.isRoomGroupMode() && this.roomGroupId && this.roomGroupId !== 'default') {
    //   this.finishLoadingGroup(this.roomGroupId)
    // }
    this.$store.commit('doc/SET_CHOSEN_DOC_FILE', this.roomDocFile)
  },

  destroyed() {
    this.$roomApi.removeEventListeners(this._events)
    this.resizeObserver.disconnect();
  },
  methods: {
    ...mapActions('doc', [
      'getRoomDocDrawList',
      'getRoomDocUrl',
      'moveRoomDocFilePage'
    ]),
    ...mapActions('roomGroup', [
      'finishLoadingGroup'
    ]),
    setRandomColorList() {
      const letters = '0123456789ABCDEF'

      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }

      this.color = color;
      this.colorList.unshift(color)
    },

    setPermission() {
      let hasRole;
      if (this.isRoomMode('CBT')){
        hasRole = false;
      } else if (!this.roomGroupId || this.roomGroupId === 'default') {
        hasRole = this.me.roomUserRole.draw;
      } else {
        hasRole = this.hasRoomGroupRole({
          roomGroupId: this.roomGroupId
        });
      }
      const defaultToolkitType = this.csCanvas.getCurrentToolkit()?.type || 'Pencil';
      this.toolkit = defaultToolkitType;
      this.csCanvas.setToolkit(hasRole ? defaultToolkitType : 'Move');
    },

    initCanvas() {
      let roomDocCanvas = RoomDocViews[this.roomDoc.roomGroupId]
      if (!roomDocCanvas) {
        roomDocCanvas = RoomDocViews[
            this.roomDoc.roomGroupId
            ] = new RoomDocCanvas({
          $vue: this,
          groupId: this.room.groupId,
          roomDoc: this.roomDoc
        })

        let el = (() => {
          if (this.$refs.roomDocView.firstElementChild) {
            this.$refs.roomDocView.removeChild(
                this.$refs.roomDocView.firstElementChild
            )
          }
          let el = this.getDocument().createElement('div')
          Object.assign(el.style, {
            position: 'relative',
            width: '100%',
            height: '100%'
          })
          return el
        })()
        roomDocCanvas.data.el = el

        this.$refs.roomDocView.appendChild(roomDocCanvas.data.el)
        roomDocCanvas.init(el)

        roomDocCanvas.csCanvas.on('changesize', () => {
          this.setStrokeStyle();
        });
      }

      Object.assign(roomDocCanvas.data, {
        $vue: this,
        groupId: this.room.groupId,
        roomDoc: this.roomDoc
      })

      this.RoomDocCanvas = roomDocCanvas
      this.csCanvas = roomDocCanvas.csCanvas

      this.$refs.roomDocView.appendChild(roomDocCanvas.data.el)

      this.setPermission();
      this.csCanvas.redraw()
    },

    async setPage(pageKey) {
      if (pageKey) {
        if (this.pageKey === pageKey) {
          return;
        }
        this.pageKey = pageKey;
      } else {
        this.pageKey = null;
      }

      let roomDocFile = this.roomDocFile
      if (!this.roomDocFile) {
        console.warn('roomDoc roomDocFileEmpty: ', this.roomGroupId, this.roomDoc, this.roomDocFile)
        return
      }

      if (this.isWhiteBoardFile(roomDocFile)) {
        await this.setWhiteboard(roomDocFile)
        return
      }

      let roomDocFilePage = this.roomDocFilePage;
      // console.log('roomDocFilePage :', roomDocFilePage);

      let imgUrl;
      if (!roomDocFilePage && roomDocFile.docFile) {
        let testDoc = new RegExp('(pdf|xls|xlsx|ppt|pptx|doc|docx|hwp)$', 'i');
        let testImg = new RegExp('(png|jpg|jpeg|bmp|gif)$', 'i');

        if (testImg.test(roomDocFile.docType)) {
          roomDocFilePage = roomDocFile;
          imgUrl = await this.getRoomDocUrl(Object.assign(roomDocFile, {roomGroupId: this.roomGroupId}));
        } else if (testDoc.test(roomDocFile.docType)) {
          // if(roomDocFile.docFile.docState === 9){
          // }
          if (!roomDocFile.pages || roomDocFile.pages.length == 0) {
            return;
          }

        }
      } else if (roomDocFilePage) {
        imgUrl = await this.getRoomDocUrl(Object.assign(roomDocFilePage, {roomGroupId: this.roomGroupId}));
      }

      if (!imgUrl) {
        console.warn('imgUrl is null', roomDocFile, roomDocFilePage);
        return
      }

      let csc = this.csCanvas
      csc.disable()

      try {
        csc.clearCanvas(false)

        let st = Date.now();
        csc.setBackgroundImage(imgUrl, async (result, img) => {
          if (!img) {
            return;
          }

          let width = img.width
          let height = img.height;
          if (this.roomSetting['useDocMargin']) {
            width *= 2;
            height *= 2;
          }

          csc.size(width, height);
          console.log('set image : %dx%d(%dms)', width, height, Date.now()-st);

          let drawList = await this.getRoomDocDrawList(roomDocFilePage)
          this.RoomDocCanvas.setDrawDataList(drawList);
        });

      } finally {
        csc.enable()
      }
    },

    async setWhiteboard(roomDocFile) {
      let csc = this.csCanvas
      csc.disable()

      try {
        csc.clearCanvas(false)

        let data = roomDocFile.docData || {
          width: 1280, height: 720, color: 'red'
        };
        csc.removeBackgroundImage();
        csc.setBackgroundColor(data.color);

        let width = data.width;
        let height = data.height;
        if (this.roomSetting['useDocMargin']) {
          width *= 2;
          height *= 2;
        }

        csc.size(width, height);

        this.RoomDocCanvas.setDrawDataList(
            await this.getRoomDocDrawList(roomDocFile)
        );
      } finally {
        csc.enable()
      }
    },

    isCurrent(draw) {
      let rd = this.roomDoc
      if (!draw.data.toolkit) {
        return rd.roomGroupId == draw.roomGroupId
      }
      return (
          rd.roomGroupId == draw.roomGroupId &&
          rd.docId == draw.docId &&
          rd.docPageId == draw.docPageId
      )
    },

    setToolkit(toolkit, e) {
      switch (toolkit) {
        case 'Eraser': {
          if (e.ctrlKey) {
            this.csCanvas.clearCanvas();
            return;
          }

          this.csCanvas.toolkits.Eraser.cursor = `url(${require('@/assets/roomType/lms/img/cursor_eraser_blue.png')}), default`;
          break;
        }
        case 'Text': {
          const fontSize = e;
          const font = this.RoomDocCanvas.getCanvasToolLineWidth('text', fontSize);
          let textToolkit = this.csCanvas.toolkits.Text;
          textToolkit.style.font = font;
          textToolkit.setTextStyle();
          break;
        }
      }

      this.toolkit = toolkit;
      this.csCanvas.setToolkit(toolkit);
    },

    changeColor(color) {
      this.color = color;
    },

    changeStrokeWidth(strokeWidth) {
      this.strokeWidth = strokeWidth;
    },

    clearCanvas() {
      this.csCanvas.clearCanvas();
    },

    drawingToolkitUrl(toolkit) {
      let obj = {
        'LaserPointer': {
          img: 'laser-pointer', title: this.$t('doc.palette.lazer')
        },
        'Pencil': {
          img: 'pen', title: this.$t('doc.palette.pen')
        },
        'Highlighter': {
          img: 'pen', title: this.$t('doc.palette.highlighter')
        },
        'Eraser': {
          img: 'Eraser', title: this.$t('doc.palette.eraser')
        },
      };

      // @/assets/roomType/lms/img/pen_off.svg
      let s = this.toolkit === toolkit ? 'on' : 'off'
      return require(`@/assets/roomType/lms/img/${obj[toolkit].img}_${s}.svg`);
    },

    zoom(z) {
      let zoom = this.csCanvas.zoom();
      this.csCanvas.zoom(zoom + z, 'center');
    },

    zoomFit() {
      this.csCanvas.zoomFit();
    },

    zoomOri() {
      this.csCanvas.zoomOri();
    },

    movePage(addPage) {
      clearTimeout(this._timer_ch_page);
      let timerMs = 250;

      if (Date.now() - (this._last_movePageTime || 0) > timerMs) {
        timerMs = 0;
      }

      this._last_movePageTime = Date.now();

      let roomDocFile = this.roomDocFile;

      let page = this.currentPageNo + addPage;
      if (page > roomDocFile.docFile.docPageCnt) {
        page = 1;
      } else if (page < 1) {
        page = roomDocFile.docFile.docPageCnt;
      }
      this.tmp_page_no = page;

      this._timer_ch_page = setTimeout(() => {
        this.moveRoomDocFilePage({
          ...this.roomDocFile, page
        });
        this.tmp_page_no = 0;
      }, timerMs);

    },

    setStrokeStyle: function () {
      let csCanvas = this.csCanvas
          , metrix = csCanvas.metrix
          , baseValue = 1200 * 900
          , ratio = (metrix.oriWidth * metrix.oriHeight) / baseValue
          , color = this.color
      ;
      this.canvasToolLineWidthRatio = ratio;

      let toolkits = csCanvas.toolkits;

      const currentToolkit = _.cloneDeep(this.csCanvas.getCurrentToolkit());

      // lazor pointer
      // toolkits.LaserPointer.cursor = 'default';
      //
      // // pencil
      // toolkits.Pencil.style.lineWidth = this.strokeWidth;
      // toolkits.Pencil.cursor = 'default';
      // toolkits.Pencil.style.strokeStyle = color;
      //
      // // highlighter
      // toolkits.Highlighter.style.lineWidth = this.strokeWidthInp;
      // toolkits.Highlighter.style.opacity = 0.4;
      // toolkits.Highlighter.cursor = 'default';
      // toolkits.Highlighter.style.strokeStyle = color;
      //
      // // eraser
      // toolkits.Eraser.style.lineWidth = 20;
      // toolkits.Eraser.cursor = `url(${require('@/assets/roomType/lms/img/cursor_eraser_blue.png')}), default`;
      //
      // // text
      // toolkits.Text.cursor = 'text';
      // toolkits.Text.style.font = this.RoomDocCanvas.getCanvasToolLineWidth('text', this.textSize || 10);
      //
      // // move
      // toolkits.Move.cursor = 'default';

      if (currentToolkit) {
        switch (currentToolkit.type) {
          case 'Pencil':
            toolkits.Pencil.style.lineWidth = currentToolkit.style.lineWidth;
            toolkits.Pencil.cursor = 'default';
            toolkits.Pencil.style.strokeStyle = currentToolkit.style.strokeStyle;
            break;
          case 'Highlighter':
            toolkits.Highlighter.style.lineWidth = currentToolkit.style.lineWidth;
            toolkits.Highlighter.style.opacity = currentToolkit.style.opacity;
            toolkits.Highlighter.cursor = 'default';
            toolkits.Highlighter.style.strokeStyle = currentToolkit.style.strokeStyle;
            break;
          case 'Eraser':
            toolkits.Eraser.style.lineWidth = currentToolkit.style.lineWidth;
            toolkits.Eraser.cursor = `url(${require('@/assets/roomType/lms/img/cursor_eraser_blue.png')}), default`;
            break;
          case 'Text':
            toolkits.Text.cursor = 'text';
            toolkits.Text.style.font = this.RoomDocCanvas.getCanvasToolLineWidth('text', this.textSize || 10);
            break;
          case 'LaserPointer':
          case 'Move':
            toolkits[currentToolkit.type].cursor = 'default';
            break;
        }
      }

    },

    onSelectText(textSize) {
      this.textSize = textSize;
      this.setToolkit('Text', textSize);
    }
  },
}

function _Events() {
  return {
    room_doc_draw: function (e) {
      let draw = e.data.draw
      if (!this.isCurrent(draw)) {
        return
      }

      if (!draw.data.v) {
        this.RoomDocCanvas.onDrawData({userId: e.data.userId, draw})
      } else if (draw.data.v == '2') {
        //
      }
    },
    room_setting_change_docMargin: function (e) {
      this.setPage()
    }
  }
}
</script>

<style lang="scss" scoped>
.room-doc-view-component {
}

.room-doc-canvas-view {
  height: 100%;
}
</style>